/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import Vue from 'vue'
import * as GmapVue from 'gmap-vue'
import visibility from 'vue-visibility-change';
import GAuth from 'vue-google-oauth2';
import VueCompositionAPI from '@vue/composition-api';
import VueFacebookPixel from 'vue-facebook-pixel';

import {radio, checkbox, linearProgress} from 'vue-material-adapter-legacy';

import moment from 'moment'

import './libraries/prototypes';
import '@stripe/stripe-js';


Vue.prototype.moment = moment;

Vue.use(VueCompositionAPI);
Vue.use(radio);
Vue.use(checkbox);
Vue.use(linearProgress);
Vue.use(VueFacebookPixel);

Vue.use(GmapVue, {
    load: {
        key: process.env.MIX_MAPS_API_KEY,
        libraries: 'places', // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then set installComponents to 'false'.
    //// If you want to automatically install all the components this property must be set to 'true':
    installComponents: true
});
Vue.use(visibility);
Vue.use(GAuth, {
    clientId: process.env.MIX_GOOGLE_CLIENT_ID,
    scope: 'profile email',
    prompt: 'select_account'
});

//per far funzionare tooltip bootstrap
Vue.directive('tooltip', {
    bind: (el, binding) => {
        $(el).tooltip({
            title: binding.value,
            placement: binding.arg,
            trigger: 'hover'
        })
    },
    update: (el, binding) => {
        const $el = $(el);
        $el.attr('title', binding.value).tooltip('_fixTitle');

        const data = $el.data('bs.tooltip');
        if (binding.modifiers.live) { // update live without flickering (but it doesn't reposition)
            if (data.tip) {
                if (data.options.html) data.tip.find('.tooltip-inner').html(binding.value);
                else data.tip.find('.tooltip-inner').text(binding.value);
            }
        } else {
            if (data._hoverState) $el.tooltip('show');
        }
    },
    unbind(el) {
        $(el).tooltip('dispose')
    }
});

import i18n from './localization'
import router from './routes'
import store from './store'

import App from './views/App'

const app = new Vue({
    el: '#app',
    components: {App},
    i18n,
    store,
    router,
});
